import { isEmpty, isEqual, isNil, isString } from 'lodash';
import { EditableField, Field } from './Field';

export interface ScheduledAutomation {
  automationTriggerDurations: string[];
}

export class ScheduledAutomationField implements EditableField {
  readonly durations: string[];
  readonly fieldType = 'ScheduledAutomationField';

  constructor(durations: string[]) {
    this.durations = durations;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof ScheduledAutomationField && isEqual(this.durations, field.durations);
  }

  toFieldJson(): ScheduledAutomation {
    return { automationTriggerDurations: this.durations };
  }

  get isEmpty() {
    return isEmpty(this.durations);
  }

  static fromFieldJson(jsonBlob: MBAPI.Scalar.JSON): ScheduledAutomationField | null {
    if (isScheduledAutomation(jsonBlob)) {
      return new ScheduledAutomationField(jsonBlob.automationTriggerDurations);
    } else {
      return null;
    }
  }
}

function isScheduledAutomation(jsonBlob: MBAPI.Scalar.JSON): jsonBlob is ScheduledAutomation {
  return (
    !isNil(jsonBlob) &&
    Array.isArray(jsonBlob.automationTriggerDurations) &&
    jsonBlob.automationTriggerDurations.every(isString)
  );
}
